const t={path:"/api/v1/farcaster/signer/init",method:"POST"},a={path:"/api/v1/farcaster/signer/status",method:"POST"};export{t as FarcasterSignerInit,a as FarcasterSignerStatus};
